module.exports = __webpack_public_path__ + "img/背景2_素材.daa896ab.svg";